import { AutocompleteItem, Card, CardBody, Button, Input, Select, SelectItem, Autocomplete, Chip } from "@heroui/react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useMemo, useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import * as XLSX from 'xlsx';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faList, faSave, faXmark } from "@fortawesome/free-solid-svg-icons";
import { apiRoute, linksUrl, URIEncrypt } from "../../constants/enum";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { connect, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setCompCode } from "../../state/companySlice";

const UserCompanyMaping = () => {
    const { compCode, } = useSelector((state) => state.company)
    const { user } = useSelector((state) => state.auth);
    const [selUserId, setSelUserId] = useState("")
    const [selCompany, setSelCompany] = useState(new Set([]))
    const navi = useNavigate();

    
    // const handleChange = (e) => {
    //     const { value, name, } = e.target
    //     setFormData({ ...formData, [name]: value })
    // }
    const handleAutoCompleteChange = (value) => {
        setSelUserId(value)
        filterUserMaping({
            data: {
                userid: value
            }
        })
    }

   
    const { data: masterData = [], isLoading } = useFetchWithBody({
        url: apiRoute.userCompMaping.masterData,
        queryKey: "fungetmasterDatamap",
        inputData: {
            client_code: user.clientCode
        }

    })


    const { data: userMapData = [], mutate: filterUserMaping } = usePost({
        url: apiRoute.userCompMaping.getUserMaping,
        queryKey: "getUsermaping",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                const selComp = data.map(ele => String(ele.COMPCODE));
                setSelCompany(new Set(selComp))
            }
            else {
                setSelCompany(new Set([]))
            }
        }

    })
    const { data = [], isPending, isError, mutate: funAddUpMaping } = usePost({
        url: apiRoute.userCompMaping.addUpdate,
        queryKey: "funAddUpdateMap",
        onSuccessTasks: (data) => {
            toast.success("Maping Updated ", {
                position: "top-center"
            })
            setSelCompany(new Set([]))
            setSelUserId("")
        }

    })

    const handleChange = (e) => {
        setSelCompany(new Set(e.target.value.split(",")));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        funAddUpMaping({
            data: {
                userid: selUserId,
                companies: [...selCompany]
            }
        })
    }

    const handleDelete = (key) => {
        const newFilter = selCompany
        newFilter.delete(key)
        setSelCompany(new Set(newFilter));
    }
    const handleReset = () => {
        setSelCompany(new Set([]))
        setSelUserId("")
    }

    if (isError) {
        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }
    return (
        <MainContainer pageName={"User Company Mapping"}
            breadcrumbs={["Settings", "User", "Company Mapping"]} >
            <div className="" style={{ textAlign: "right" }}>
            </div>
            <Card>
                <form onSubmit={handleSubmit} autoComplete='off'>
                    <CardBody className="h-screen">
                        <div className="flex gap-4 align-top items-baseline mb-2">
                            <Autocomplete
                                size="sm"
                                name={"user"}
                                label={"User"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                labelPlacement={"outside"}
                                placeholder={""}
                                isRequired
                                isLoading={isLoading}
                                color="warning"
                                className="max-w-23 font-semibold"
                                classNames={{
                                    label: "font-semibold",
                                }}
                                isClearable={false}
                                isVirtualized
                                // readonly={isNewEntry ? false : true}
                                defaultItems={
                                    masterData && masterData.userMaster ? masterData.userMaster : []
                                }
                                onSelectionChange={handleAutoCompleteChange}
                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                //onChange={handleFormSelectionChange}
                                selectedKey={selUserId}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.LoginName}
                                    >
                                        {`${list.UserName}' '(${list.LoginName})`}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>


                        </div>
                        <div className="flex gap-4 align-top items-center mb-2">


                            <Select
                                className="w-full "
                                isMultiline={true}
                                color="danger"
                                classNames={{
                                    //base: "max-w-md",
                                    label: "font-semibold"
                                    //trigger: "min-h-5 py-2",
                                }}
                                items={masterData && masterData.compMaster ? masterData.compMaster : []}
                                label="Select Company"
                                labelPlacement="outside"
                                isLoading={isLoading}
                                size="sm"
                                renderValue={(items) => {
                                    return (
                                        <div className="flex flex-wrap gap-2">
                                            {items.map((item) => (
                                                <div className="flex">
                                                    <Chip size="sm" radius="sm" variant="flat" color="default" key={item.key}><strong> {item.data.CompName}</strong></Chip>
                                                    <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelete(item.key)} icon={faXmark} /></div>
                                            ))}
                                        </div>
                                    );
                                }}

                                selectedKeys={selCompany}
                                selectionMode="multiple"
                                onChange={handleChange}
                                variant="flat"
                            >
                                {(list) => (
                                    <SelectItem
                                        key={list.CompCode}
                                    >
                                        {list.CompName}
                                    </SelectItem>
                                )}
                            </Select>



                        </div>

                        <div className="flex  justify-center gap-4 align-top items-center mb-2">
                            <Button
                                color="primary"
                                type="submit"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Save
                            </Button>
                            <Button
                                color="default"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                onPress={handleReset}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancle
                            </Button>
                        </div>
                    </CardBody>
                </form>
            </Card>
        </MainContainer>
    )
}
export default UserCompanyMaping